import React from 'react'
import documentStatusColor from '../../services/documentStatusColor'
import { useAppData } from '../../../../context/AppDataContext';

function CounterData({report,documentTypeMatrix }) {

    const {userDD,getDDDataById} = useAppData();
    console.log(report);
    return (
        <>
            <div className="row mt-4">
                {report.documentStatus.map(documentStatus=>
                    <div className="col-md-2 col-sm-6 col-xs-6">
                        <div className={"card shadow  p-1 " + documentStatusColor[documentStatus.status]} >
                            <p>{documentStatus.label}</p>
                            <span className="text-center"><h1>{documentStatus.count}</h1></span>
                        </div>
                    </div>
                )}
            </div>
            <div className="row mt-4">
                <div className="col-md-8">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th width="40%"></th>
                                {documentTypeMatrix[0].statuses.map(documentStatus=>
                                    <td width="10%" className={"text-center " + documentStatusColor[documentStatus.statusId]}>{documentStatus.statusLabel}</td>
                                )}
                                <th width="10%" className="text-center bg-dark text-white">Total</th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                        <tbody>
                            {documentTypeMatrix.map(documentType=>
                                <tr key={documentType.typeId}>
                                    <td>{documentType.typeLabel}</td>
                                    {documentType.statuses.map(documentStatus=>
                                        <td width="10%" className={"text-center " + documentStatusColor[documentStatus.statusId]}>{documentStatus.count}</td>
                                    )}
                                     <th width="10%" className="text-center bg-dark text-white">{documentType.totalCount}</th>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className='col-md-4'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Staff / Assignee</th>
                                <th className='bg-success text-white'>Count</th>
                            </tr>
                            {report.assignedTo.map(assignee=>
                                <tr key={assignee.assignedTo}>
                                    <td>{isNaN(assignee.assignedTo) ? assignee.label: getDDDataById(userDD,assignee.assignedTo).label}</td>
                                    <td>{assignee.count}</td>
                                </tr>
                            )}
                            
                        </thead>
                    </table>
                </div>
            </div>
        </>
    )
}

export default CounterData